import React from "react";
import "./About.css"; // Import the CSS file
import presidentImage from "../../Assets/president.jpg";
import aboutImage from "../../Assets/about.jpg"; 
import correspondantImage from "../../Assets/correspondant.jpg";
import headmistressImage from "../../Assets/headmistress.png";


const About = () => {
  return (
    <div className="about-page">
      {/* About Image Section */}
      <div className="about-image-container">
        <img src={aboutImage} alt="About School" />
      </div>

      {/* Chairman Section */}
      <div className="about-section">
        <div className="about-us">
          <h2 style={{ textAlign: "center" }}>About Us</h2>
          <div className="about">
            <p>
              V.D. Prasada Rao Memorial High School, sponsored by the V.D. Prasada Rao Educational Society, is dedicated to meeting the growing educational needs of children in Sri Rama Krishna Puram and surrounding colonies. The school is known for its discipline, commitment to quality education, and a nurturing environment that fosters academic, physical, moral, and aesthetic development.
            </p>
          </div>
        </div>
      </div>

      {/* Mission and Vision Section */}
      <div className="mission-vision-section">
        <div className="mission">
          <h2 style={{ textAlign: "center" }}>Our Mission</h2>
          <p>
            At V.D. Prasada Rao Memorial High School, our mission is to provide a holistic education that focuses on academic excellence, character development, and leadership skills. We strive to create a learning environment that empowers our students to become well-rounded individuals with a strong sense of responsibility, discipline, and respect for themselves and others.
          </p>
        </div>
        <div className="vision">
          <h2 style={{ textAlign: "center" }}>Our Vision</h2>
          <p>
            Our vision is to be a leading institution that molds young minds into responsible, compassionate, and forward-thinking citizens of tomorrow. We envision a school where every student has the opportunity to grow academically, socially, and emotionally in a safe and inclusive environment.
            We aim to nurture the intellectual curiosity, creativity, and critical thinking skills of our students, preparing them to meet the challenges of the future with confidence and resilience.
          </p>
        </div>
      </div>

      {/* Members Section */}
      <div className="members-section">
        <h2>Our Members</h2>
        
        {/* President Image Centered */}
        <div className="president-container">
          <img src={presidentImage} alt="President" className="president-image" />
          <h3>President</h3>
          <p className="president-name">Dr. V.V.S. SARMA<br /><sub>M.D., D.M., M.R</sub></p>
          <p style={{textAlign: "justify"}}>
                {/* write about president here  */}
                
            </p>
        </div>
       

        <div className="correspondant-container">
          <img src={correspondantImage} alt="correspondant" className="correspondant-image"/>
          <h3>Correspondent</h3>
            <p>C. Narayana Murthy</p>
            <sub>M.Com.</sub>
            
        </div>
      
      
        <div className="correspondant-container">
        <img src={headmistressImage} alt="headmistress" className="correspondant-image"/>
            <h3>Head Mistress</h3>
            <p>D. Jayasree</p>
            <sub>M.A. (Eng.), M.A. (Pub.Ad.), B.Ed.</sub>
          </div>
        </div>
      

      <div className="general-info-section">
        <div className="working-hours">
          <h2 style={{ textAlign: "center" }}>Working Hours</h2>
          <p>
            <b>Forenoon Session</b>: 9:00 a.m. to 12:20 p.m.<br />
            <b>Lunch Break</b>: 12:20 p.m. to 12:50 p.m.<br />
            <b>Afternoon Session</b>: 12:50 p.m. to 4:30 p.m.<br />
          </p>
        </div>
        <div className="leaving-time">
          <h2 style={{ textAlign: "center" }}>Leaving Time</h2>
          <p>
            <b>Pre-Primary Children (Nursery, LKG, UKG)</b>: Leave by 2:10 p.m.<br />
            <b>Primary Children (Class I to V)</b>: Leave by 4:00 p.m.<br />
            <b>High School Children (Class VI to X)</b>: Leave by 4:30 p.m.<br />
            
          </p>
        </div>
      </div>
      <section className="uniform-section">
      <h2 className="section-title">Uniform</h2>
      <p className="uniform-description">
        Uniform is compulsory for all students. Students of I to X Class have to wear house dress on every Wednesday compulsorily.
      </p>
      <div className="uniform-table-container">
        <table className="uniform-table">
          <thead>
            <tr>
              <th>Uniform</th>
              <th>Colour</th>
              <th>On Every Wednesday</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Shirt</td>
              <td>Sky Blue Checks</td>
              <td>House Dress</td>
            </tr>
            <tr>
              <td>Frock/Nicker/Skirt/Pant</td>
              <td>Blue</td>
              <td></td>
            </tr>
            <tr>
              <td>Shoes</td>
              <td>Black</td>
              <td>White Canvas</td>
            </tr>
            <tr>
              <td>Socks</td>
              <td>Blue with Stripes</td>
              <td>White</td>
            </tr>
            <tr>
              <td>Belt</td>
              <td>Provided by School</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

      {/* Additional Information Section */}
      <section className="additional-info-section">
        <h2 className="section-title">Academic Policies and Student Guidelines</h2>
        <h3> Progress Reports</h3>
        <p>The school shall conduct Formative Assessments (FAs) and Summative Assessments (SAs) as per the CCE guidelines.</p>
        <p>Promotion of students to a higher class will be based on rules and regulations communicated from time to time by the education department.</p>
        <p>Progress reports shall be sent to parents/guardians for their information and review.</p>
        <p>The Formative & Summative Assessments scripts shall be sent to the guardian. They should be returned to the teacher within the week.</p>
        
        
        
        <h3>Mode of Fee Payment</h3>
        <p>Students from Nursery to Class X have to pay the total fee in three equal installments:</p>
        <ul>
          <li>June</li>
          <li>October</li>
          <li>December</li>
        </ul>
        
        <h3>Games & Sports</h3>
        <p>The school encourages participation in games, sports, and cultural programs.</p>
        <p>Talented students will receive special training.</p>
        
        <h3>Educational Excursions</h3>
        <p>Educational excursions will be organized once per annum under the personal supervision of the Principal.</p>
        
        <h3>Code of Conduct for Students</h3>
        <p>Every student must abide by the school's discipline guidelines.</p>
        <p>Maintaining good conduct is essential.</p>
      </section>
    </div>
  );
};

export default About;
